import { useMemo } from 'react';
import { useBusinessProfileStore } from '../store/useBusinessProfileStore';
import { usePlanEntitlements } from '../../providers/PlanEntitlementsProvider';
import { useGlobalFeatureFlags } from '../../providers/GlobalFeatureFlagsProvider';
import {
  resolveEffectiveCapabilities,
  type CapabilityGateContext,
} from '../../feature-flags/businessCapabilitiesService';
import type { BusinessCapability } from '../domain/businessProfile';

export function useEffectiveBusinessCapabilities(): Set<BusinessCapability> {
  const profile = useBusinessProfileStore((s) => s.profile);
  const { entitlements } = usePlanEntitlements();
  const { flags } = useGlobalFeatureFlags();

  return useMemo(() => {
    const ctx: CapabilityGateContext = {
      profile,
      entitlements: entitlements ?? null,
      featureFlags: flags ?? null,
    };
    return resolveEffectiveCapabilities(ctx);
  }, [profile, entitlements, flags]);
}

export function useHasBusinessCapability(capability: BusinessCapability): boolean {
  const caps = useEffectiveBusinessCapabilities();
  return caps.has(capability);
}
